<script setup>
import moment from "moment/moment";
import {computed, onMounted, ref, toRef} from "vue";
import forestreeHelpers from "../../../../helpers/forestreeHelpers.js";
import AssignWork from "@/components/AssignWork.vue";
import Notes from "@/components/Notes.vue";
const props = defineProps(["requests", "users", "teams", "permissions", "defaults"]);

const today = ref(moment().format("dddd Do MMM YYYY"));
const suburbs = ref([]);
const workTypes = ref([]);
const equipment = ref([]);
const selectedSuburb = ref("Show All");
const selectedWorkType = ref("Show All");
const selectedPriority = ref("Show All");
const selectedEquip = ref("Show All");
const selectedUser = ref([]);
const assignWork = ref(null);
const assignTypeId = ref(null);
const showAssign = ref(false);

const openAssignModal = (work, typeId) => {
    assignWork.value = work;
    assignTypeId.value = typeId;
    showAssign.value = true;
};
const toggleToArray = (userId) => {
    if (selectedUser.value.includes(userId)) {
        selectedUser.value.splice(selectedUser.value.indexOf(userId), 1);
    } else {
        selectedUser.value.push(userId);
    }
};

const getSuburbs = () => {
    suburbs.value = [];
    props.requests.map((work) => {
        if (work.crm_suburb) {
            if (!suburbs.value.includes(work.crm_suburb)) {
                suburbs.value.push(work.crm_suburb);
            }
        }
    });
    suburbs.value.sort();
};
const getEquipment = () => {
    equipment.value = [];
    props.requests.map((work) => {
        if (work.equipment_req?.length > 0) {
            work.equipment_req.map(e => {
                if (!equipment.value.includes(e.name)) {
                    equipment.value.push(e.name);
                }
            })
        }
    });
    equipment.value.sort();
};
const getWorkTypes = () => {
    workTypes.value = [];
    props.requests.map((work) => {
        if (work.work_type) {
            if (!workTypes.value.includes(work.work_type)) {
                workTypes.value.push(work.work_type);
            }
        }
    });
    workTypes.value.sort();
};

onMounted(() => {
    getWorkTypes();
    getEquipment();
    getSuburbs();
});

const filteredList = computed(() => {
    return props.requests.filter((work) => {
        var e = work.equipment_req ? work.equipment_req.name : null;

        return (
            (selectedSuburb.value === "Show All" || work.crm_suburb === selectedSuburb.value) &&
            (selectedWorkType.value === "Show All" || selectedWorkType.value === work.work_type) &&
            (selectedPriority.value === "Show All" || selectedPriority.value === work.external_priority) &&
            (selectedEquip.value === "Show All" || selectedEquip.value === e)
        );
    });
});
const filteredSuburbs = computed(() => {
    if (selectedSuburb.value !== "Show All") {
        return props.requests.filter((work) => {
            if (work.crm_suburb) {
                return work.crm_suburb === selectedSuburb.value;
            }
        });
    }
    return props.requests;
});
</script>

<template>
    <div>
        <div class="w-full flex flex-wrap lg:flex-no-wrap pb-8">
            <div class="w-full lg:w-1/2">
                <div class="w-full">
                    <p class="my-3 text-2xl text-slate-600">
                        Customer Requests
                        <span v-if="requests">({{ requests.length }})</span>
                    </p>
                </div>
                <div class="w-full text-md text-slate-500 mb-3">Below shows current Customer Requests.</div>
            </div>
        </div>
        <div class="w-full flex flex-wrap lg:flex-no-wrap pb-8">
            <div class="w-full lg:w-1/4">
                <div class="flex justify-end">
                    <div class="w-full items-center pr-4">
                        <p class="whitespace-nowrap text-slate-600 text-sm uppercase font-semibold mb-2">Filter Work
                            Type</p>
                        <select
                            v-model="selectedWorkType"
                            class="block appearance-none w-full bg-slate-100 border border-slate-200 text-slate-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-slate-500 rounded-lg"
                            id="grid-state"
                        >
                            <option value="Show All">SHOW ALL</option>
                            <option v-for="work in workTypes" :value="work" :key="work">{{ work }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/4">
                <div class="flex justify-end">
                    <div class="w-full items-center pr-4">
                        <p class="whitespace-nowrap text-slate-600 text-sm uppercase font-semibold mb-2">Filter
                            Suburb</p>
                        <select
                            v-model="selectedSuburb"
                            class="block appearance-none w-full bg-slate-100 border border-slate-200 text-slate-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-slate-500 rounded-lg"
                            id="grid-state"
                        >
                            <option value="Show All">SHOW ALL</option>
                            <option v-for="suburb in suburbs" :value="suburb" :key="suburb">{{ suburb }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/4 pr-4">
                <div class="flex justify-end">
                    <div class="w-full items-center">
                        <p class="whitespace-nowrap text-slate-600 text-sm uppercase font-semibold mb-2">Filter
                            Priority</p>
                        <select
                            v-model="selectedPriority"
                            class="block appearance-none w-full bg-slate-100 border border-slate-200 text-slate-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-slate-500 rounded-lg"
                            id="grid-state"
                        >
                            <option value="Show All">SHOW ALL</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/4 pr-4">
                <div class="flex justify-end">
                    <div class="w-full items-center">
                        <p class="whitespace-nowrap text-slate-600 text-sm uppercase font-semibold mb-2">Equipment
                            Req.</p>
                        <select
                            v-model="selectedEquip"
                            class="block appearance-none w-full bg-slate-100 border border-slate-200 text-slate-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-slate-500 rounded-lg"
                            id="grid-state"
                        >
                            <option value="Show All">SHOW ALL</option>
                            <option v-for="e in equipment" :value="e" :key="e">
                                {{ e }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="ftree-table striped hovered main-first-cell w-full overflow-x-auto">
            <div class="thead">
                <div class="tr py-2">
                    <div class="td items-center w-1/2 lg:w-1/6">Request ID</div>
                    <div class="td items-center w-1/2 lg:w-2/6">Details</div>
                    <div v-if="users" class="td items-center w-1/2 lg:w-1/6">Assigned To</div>
                    <div class="td items-center w-1/2 lg:w-1/6">Date Lodged</div>
                    <div v-if="defaults && defaults.pathway_integration" class="td items-center w-1/2 lg:w-1/6">Respond
                        By
                    </div>
                    <div class="td items-center w-1/2 lg:w-1/6">Due Date</div>
                </div>
            </div>

            <div v-if="`filteredList`" class="tbody text-left text-slate-700">
                <div v-for="(request, index) in filteredList" :key="index"
                     class="border-b border-slate-200 hover:bg-slate-100">
                    <div class="tr">
                        <div class="td td-block-wrap py-2 w-1/2 lg:w-1/6 items-center">
                            <div class="py-1 w-full">
                                <a :href="'/maintenance-map?crmId=' + request.crm_id"
                                   class="inline-block text-slate-600 font-bold mr-3 py-1"
                                >#{{ request.crm_id }}</a
                                >
                            </div>
                            <div v-if="request.tree_id" class="py-1 w-full">
                                <a :href="'/map?treeId=' + request.tree_id"
                                   class="inline-block text-slate-500 font-semibold py-1"
                                >Tree ID #{{ request.tree_id }}</a
                                >
                            </div>
                        </div>
                        <div class="td td-block-wrap py-2 w-1/2 lg:w-2/6 items-center">
                            <div class="py-1 w-full">
                                <span v-if="request.status === 'Complete'"
                                      class="inline-block bg-green-500 rounded-full px-3 py-1 text-sm text-green-200 mr-2">
                                    {{ request.status }}
                                </span>
                                <span v-if="request.address"
                                      class="inline-block bg-slate-500 rounded-full px-3 py-1 text-sm text-slate-200 mr-2">
                                    {{ request.address }}
                                </span>
                            </div>

                            <div class="w-full">
                                <!-- <span 
                            v-if="request.work_type"
                            class="inline-block bg-slate-600 rounded-full px-3 text-sm text-slate-100 hover:text-slate-300 mr-1 py-1">
                              {{request.work_type}}
                          </span> -->
                                <span v-if="request.external_priority === '5'"
                                      class="inline-block rounded-full px-3 py-1 text-sm text-white my-1 bg-blue-500"
                                >Priority {{ request.external_priority }}</span
                                >
                                <span v-if="request.external_priority === '4'"
                                      class="inline-block rounded-full px-3 py-1 text-sm text-white my-1 bg-green-500"
                                >Priority {{ request.external_priority }}</span
                                >
                                <span v-if="request.external_priority === '3'"
                                      class="inline-block rounded-full px-3 py-1 text-sm text-white my-1 bg-orange-500"
                                >Priority {{ request.external_priority }}</span
                                >
                                <span v-if="request.external_priority === '2'"
                                      class="inline-block rounded-full px-3 py-1 text-sm text-white my-1 bg-red-600"
                                >Priority {{ request.external_priority }}</span
                                >
                                <span v-if="request.external_priority === '1'"
                                      class="inline-block rounded-full px-3 py-1 text-sm text-white my-1 bg-purple-600"
                                >Priority {{ request.external_priority }}</span
                                >
                                <span v-if="request.external_status"
                                      class="inline-block rounded-full px-3 text-white text-sm py-1 bg-slate-700 ml-1">{{
                                        request.external_status.name
                                    }}</span>

                                <span v-if="request.equipment_req"
                                      class="inline-block rounded-full px-3 py-1 text-sm text-white my-1 bg-blue-500 mr-1"
                                v-for="(equipment) in request.equipment_req">
                                    {{ equipment.name }}
                                </span>
                            </div>

                            <div class="pb-1 w-full text-sm text-slate-500 items-center" style="white-space: pre-line">
                                <notes :text="request.notes"/>
                            </div>
                            <div v-if="request.url" class="py-2 w-full">
                                <a :href="request.url" target="_blank"
                                   class="w-full text-xs text-blue-500 hover:text-blue-600 items-center">
                                    {{ request.url }}
                                </a>
                            </div>
                        </div>

                        <assign-work
                            v-if="users"
                            class="w-1/2 lg:w-1/6 pr-1"
                            :work="request"
                            :users="users"
                            :teams="teams"
                            assignTypeId="6"
                            :permissions="permissions"
                        />
                        <div v-if="request.lodged_date" class="td py-2 w-1/2 lg:w-1/6 items-center text-slate-500">
                            {{ forestreeHelpers.dateTime(request.lodged_date, true) }}
                        </div>
                        <div v-else class="td py-2 w-1/2 lg:w-1/6 items-center text-slate-500">
                            {{ forestreeHelpers.dateTime(request.created_at, true) }}
                        </div>

                        <div v-if="defaults && defaults.pathway_integration"
                             class="td py-2 w-1/2 lg:w-1/6 items-center text-slate-500">
                            {{ forestreeHelpers.dateTime(request.respond_by_date,true) }}
                        </div>
                        <div v-if="defaults && defaults.spreadsheet_crms"
                             class="td py-2 w-1/2 lg:w-1/6 items-center text-slate-500">
                            {{ forestreeHelpers.dateTime(request.crm_due_date,true) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.td-block-wrap {
    display: block !important;
}
</style>
